import BaseModel from '../core/BaseModel'
export default class AvailableResponseModel extends BaseModel {

    constructor() {
        super({
                name: "available_reponse",
                tableName: 'available_reponse',
                label: "Available response"
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                }
            })
    }

}